import { Button } from "react-bootstrap";
import styled, { css } from "styled-components";

import { fontFamily } from "../grid.js";
import {
  TimelineEventDefault,
  TimelineFamilyAndChild,
  TimelineHolidaysAndLeave,
  TimelinePaid,
  TimelineSicknessAndRehabilitation,
  TimelineTrainingAndEducation,
  TimelineUnpaid,
} from "../icons.jsx";

export const IconContainer = styled.div`
  min-width: 30px;
`;

export const CalendarEventStyled = styled("div").attrs({
  className: "CalendarEventStyled",
})`
  position: relative;
  display: flex;
  align-items: center;
  height: 48px;
  border-radius: 24px;
  padding: 0.5rem 1.25rem;

  &.icon-only {
    padding: 0.5rem 0;
  }

  ${(props) =>
    props.colour &&
    css`
      background-color: ${props.colour};
    `}

  &.open {
    ${(props) =>
    props.colour &&
    css`
        border: 2px solid ${props.colour};
        background-color: white;
      `}
  }

  gap: 1rem;
`;

export const TimelineEventLabel = styled("div")`
  overflow: hidden;
`;
export const TimelineIconAndLabel = styled("div")`
  overflow: hidden;
  min-width: 30px;
`;
export const TimelineEventName = styled("div")`
  margin-bottom: 0.25rem;
  font:
    600 13px/1 ${fontFamily},
    "Segoe UI",
    sans-serif;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  ${(props) =>
    props.colour &&
    css`
      color: ${props.colour};
    `}
`;

export const TimelineEventStatus = styled("div")`
  display: flex;
  gap: 0.25rem;
  font:
    500 11px/1 ${fontFamily},
    "Segoe UI",
    sans-serif;
  ${(props) =>
    props.colour &&
    css`
      color: ${props.colour};
    `}
`;

export const TimelineEventStatusLabel = styled("div")`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const TimelineDuration = styled("div")`
  font:
    600 11px/1 ${fontFamily},
    "Segoe UI",
    sans-serif;
  ${(props) =>
    props.colour &&
    css`
      color: ${props.colour};
    `}
`;

export const timelineEventThemes = {
  paid: {
    backgroundColor: "rgba(195, 248, 233, 1)",
    textColor: "rgba(9, 64, 51, 1)",
    Icon: TimelinePaid,
  },
  trainingAndEducation: {
    backgroundColor: "rgba(226, 217, 243, 1)",
    textColor: "rgba(78, 45, 137, 1)",
    Icon: TimelineTrainingAndEducation,
  },
  sicknessAndRehabilitation: {
    backgroundColor: "rgba(255, 202, 221, 1)",
    textColor: "rgba(135, 0, 92, 1)",
    Icon: TimelineSicknessAndRehabilitation,
  },
  holidaysAndLeave: {
    backgroundColor: "rgba(204, 241, 250, 1)",
    textColor: "rgba(0, 103, 159, 1)",
    Icon: TimelineHolidaysAndLeave,
  },
  familyAndChild: {
    backgroundColor: "rgba(253, 229, 243, 1)",
    textColor: "rgba(135, 0, 92, 1)",
    Icon: TimelineFamilyAndChild,
  },
  unPaid: {
    backgroundColor: "rgba(255, 239, 194, 1)",
    textColor: "rgba(106, 75, 25, 1)",
    Icon: TimelineUnpaid,
  },
  default: {
    backgroundColor: "#CAE4FF",
    textColor: "#00679F",
    Icon: TimelineEventDefault,
  },
};

export const rejectedColors = {
  backgroundColor: "rgba(234, 232, 228, 1)",
  textColor: "rgba(103, 103, 103, 1)",
};

//export const TimelineEventOverlay = styled("div")`
//  position: absolute;
//  display: flex;
//  align-items: center;
//  justify-content: center;
//  height: 100%;
//  width: 100%;
//  border-radius: 24px;
//  left: 0;
//  top: 0;
//  background-color: rgba(104, 139, 176, 0.48);
//  gap: 0.5rem;
//`;

export const TimelineEventPopover = styled.div`
  margin-bottom: 0.5rem;
  background: white;
  border-radius: 8px;
  padding: 8px 12px;
  min-width: 240px;

  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
`;

export const PopoverActions = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 6px;
`;

export const PopoverInfo = styled.div`
  color: black;
  font-family: Borna;
  font-size: 13px;
`;

export const PopoverEdit = styled.div`
  font-size: 0.8rem;
  color: var(--heeros-blue-600);
  cursor: pointer;
  text-decoration: underline;
`;

export const TimeLineEventOverlayButton = styled(Button)`
  width: 2rem;
  height: 2rem;
  background-color: var(--heeros-purple-600-brand);
  padding: 0;
  border-radius: 1rem;
  border: 0;

  ${({ $action }) =>
    $action === "approve" &&
    css`
      background-color: var(--heeros-purple-600-brand);
      &:hover {
        background-color: var(--heeros-purple-600-brand);
      }
    `};

  ${({ $action }) =>
    $action === "decline" &&
    css`
      background-color: var(--heeros-yellow-600);
      &:hover {
        background-color: var(--heeros-yellow-600);
      }
    `};

  ${({ $action }) =>
    $action === "edit" &&
    css`
      background-color: var(--heeros-blue-600);
      &:hover {
        background-color: var(--heeros-blue-600);
      }
    `};
`;
